export const STORAGE_AVATARS_LOCATION = "avatars";
export const STORAGE_EVENTS_LOCATION = "events";
export const STORAGE_FEED_POSTS_LOCATION = "feedPosts";
export const STORAGE_PROFILE_IMAGES_LOCATION = "profileImages";
